var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import http, { Q, Api } from "@http";
import { observable, action, runInAction } from "mobx";
import { PredefinedClient } from "@common/enums/base";
import { initFavicon } from "@common/utils";
var AccountStore = /** @class */ (function () {
    function AccountStore() {
        this.clientInfo = {};
        this.userLoginData = {};
        this.userIdentity = {};
        this.residentInfo = {};
        this.checkCreateUserName = false;
    }
    AccountStore.prototype.getClientInfo = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api().getClientInfo()];
                    case 1:
                        data = _a.sent();
                        runInAction(function () {
                            _this.clientInfo = data;
                            initFavicon(data.clientId);
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    AccountStore.prototype.userLogin = function (param) {
        return __awaiter(this, void 0, Promise, function () {
            var promise, data;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        promise = this.api().getUserLogin({
                            userName: param.userName,
                            password: param.password,
                            utcOffset: param.utcOffset != null ? param.utcOffset : -480,
                            isSupportDST: param.isSupportDST || false
                        });
                        return [4 /*yield*/, promise];
                    case 1:
                        data = _a.sent();
                        runInAction(function () {
                            _this.userLoginData = data;
                        });
                        return [2 /*return*/, promise];
                }
            });
        });
    };
    AccountStore.prototype.forGotPasswordSendEmail = function (email) {
        return __awaiter(this, void 0, Promise, function () {
            var promise;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api().forGotPasswordSendEmail(email)];
                    case 1:
                        promise = _a.sent();
                        return [2 /*return*/, promise];
                }
            });
        });
    };
    AccountStore.prototype.forgotPasswordByUserName = function (userName) {
        return __awaiter(this, void 0, Promise, function () {
            var promise;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api().forgotPasswordByUserName(userName)];
                    case 1:
                        promise = _a.sent();
                        return [2 /*return*/, promise];
                }
            });
        });
    };
    AccountStore.prototype.forGotPasswordSendVerificationCode = function (phoneNumber) {
        return __awaiter(this, void 0, Promise, function () {
            var promise;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api().forGotPasswordSendVerificationCode(phoneNumber)];
                    case 1:
                        promise = _a.sent();
                        return [2 /*return*/, promise];
                }
            });
        });
    };
    AccountStore.prototype.sendOneTimeCode = function (query) {
        return __awaiter(this, void 0, Promise, function () {
            var promise;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api().sendOneTimeCode(query)];
                    case 1:
                        promise = _a.sent();
                        return [2 /*return*/, promise];
                }
            });
        });
    };
    AccountStore.prototype.verifyOneTimeCode = function (query) {
        return __awaiter(this, void 0, Promise, function () {
            var promise;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api().verifyOneTimeCode(query)];
                    case 1:
                        promise = _a.sent();
                        return [2 /*return*/, promise];
                }
            });
        });
    };
    AccountStore.prototype.verifyCode = function (phoneNumber, code) {
        return __awaiter(this, void 0, Promise, function () {
            var promise;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api().verifyCode(phoneNumber, code)];
                    case 1:
                        promise = _a.sent();
                        return [2 /*return*/, promise];
                }
            });
        });
    };
    AccountStore.prototype.checkEmailToken = function (userName, token) {
        return __awaiter(this, void 0, Promise, function () {
            var request, promise;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = {
                            userName: userName,
                            token: token
                        };
                        return [4 /*yield*/, this.api().checkEmailToken(request)];
                    case 1:
                        promise = _a.sent();
                        return [2 /*return*/, promise];
                }
            });
        });
    };
    AccountStore.prototype.createUserByEmail = function (email, token, residentId) {
        return __awaiter(this, void 0, Promise, function () {
            var request, promise;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = {
                            email: email,
                            token: token,
                            residentId: residentId
                        };
                        return [4 /*yield*/, this.api().createUserByEmail(request)];
                    case 1:
                        promise = _a.sent();
                        return [2 /*return*/, promise];
                }
            });
        });
    };
    AccountStore.prototype.register = function (userIdentity) {
        return __awaiter(this, void 0, Promise, function () {
            var promise;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api().register(userIdentity)];
                    case 1:
                        promise = _a.sent();
                        return [2 /*return*/, promise];
                }
            });
        });
    };
    AccountStore.prototype.sendEmailByToken = function (token) {
        return __awaiter(this, void 0, Promise, function () {
            var promise;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api().sendEmailByToken(token)];
                    case 1:
                        promise = _a.sent();
                        return [2 /*return*/, promise];
                }
            });
        });
    };
    AccountStore.prototype.getResidentInfo = function (residentId, token, clientId) {
        return __awaiter(this, void 0, Promise, function () {
            var promise, data;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        promise = this.api().getResidentInfo(residentId, token, clientId);
                        return [4 /*yield*/, promise];
                    case 1:
                        data = _a.sent();
                        runInAction(function () {
                            _this.residentInfo.AddressLine1 = data.AddressLine1;
                            _this.residentInfo.Email = data.Email;
                            _this.residentInfo.ClientId = data.ClientId;
                            _this.residentInfo.LocationId = data.LocationId;
                            _this.residentInfo.Phone = data.Phone;
                            if (data.ClientId === PredefinedClient.IH.toString()) {
                                _this.residentInfo.userName = data.Name;
                            }
                            _this.residentInfo.residentName = data.Name;
                            if (_this.residentInfo.residentName) {
                                var residentNameArray = _this.residentInfo.residentName.split(" ");
                                if (residentNameArray.length > 0) {
                                    _this.residentInfo.firstName = residentNameArray[0];
                                }
                                _this.residentInfo.lastName = residentNameArray[1];
                            }
                        });
                        return [2 /*return*/, promise];
                }
            });
        });
    };
    AccountStore.prototype.getSignUpByEmail = function (residentId, token, clientId) {
        return __awaiter(this, void 0, Promise, function () {
            var promise, data;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        promise = this.api().getSignUpByEmail(residentId, token, clientId);
                        return [4 /*yield*/, promise];
                    case 1:
                        data = _a.sent();
                        runInAction(function () {
                            _this.jumpUrl = data;
                        });
                        return [2 /*return*/, promise];
                }
            });
        });
    };
    AccountStore.prototype.checkEmail = function (email) {
        return __awaiter(this, void 0, Promise, function () {
            var promise;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api().checkEmail(email)];
                    case 1:
                        promise = _a.sent();
                        return [2 /*return*/, promise];
                }
            });
        });
    };
    AccountStore.prototype.getCheckCreateUserNameResult = function (userName) {
        return __awaiter(this, void 0, Promise, function () {
            var promise, data;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        promise = this.api().CheckCreateUserName(userName);
                        return [4 /*yield*/, promise];
                    case 1:
                        data = _a.sent();
                        runInAction(function () {
                            _this.checkCreateUserName = data;
                        });
                        return [2 /*return*/, promise];
                }
            });
        });
    };
    AccountStore.prototype.resetPassword = function (resetPasswordModel) {
        return __awaiter(this, void 0, Promise, function () {
            var promise, data;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api().resetPassword({
                            password: resetPasswordModel.password,
                            confirmPassword: resetPasswordModel.confirmPassword
                        })];
                    case 1:
                        promise = _a.sent();
                        return [4 /*yield*/, promise];
                    case 2:
                        data = _a.sent();
                        runInAction(function () {
                            _this.resetPasswordResult = data;
                        });
                        return [2 /*return*/, promise];
                }
            });
        });
    };
    AccountStore.prototype.getResidentDetailByPhone = function (phoneNumber) {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.api().getResidentDetailsByPhone(phoneNumber, this.clientInfo.clientCode)];
            });
        });
    };
    AccountStore.prototype.getResidentContactListByLocation = function (request) {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                request.clientCode = this.clientInfo.clientCode;
                return [2 /*return*/, this.api().getResidentContactListByLocation(request)];
            });
        });
    };
    AccountStore.prototype.verifyOtp = function (request) {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                request.clientCode = this.clientInfo.clientCode;
                return [2 /*return*/, this.api().verifyOTP(request)];
            });
        });
    };
    AccountStore.prototype.getResidentAddress = function (address) {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.api().getResidentAddress(address, this.clientInfo.clientId)];
            });
        });
    };
    AccountStore.prototype.getCallCenterPhone = function () {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.api().getCallCenterPhone(this.clientInfo.clientCode)];
            });
        });
    };
    AccountStore.prototype.getResidentCity = function (city) {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.api().getResidentCity(city, this.clientInfo.clientId)];
            });
        });
    };
    AccountStore.prototype.getResidentState = function (state) {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.api().getResidentState(state, this.clientInfo.clientId)];
            });
        });
    };
    AccountStore.prototype.sendOTPToPhone = function (request) {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                request.clientCode = this.clientInfo.clientCode;
                return [2 /*return*/, this.api().sendOTPToPhone(request)];
            });
        });
    };
    AccountStore.prototype.signInByOtp = function (accessToken, eventId) {
        return this.api().signInByOTP(accessToken, eventId);
    };
    AccountStore.prototype.logout = function () {
        return this.api().logout();
    };
    AccountStore.prototype.getConfirmedPhone = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api().getConfirmedPhone()];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, data];
                }
            });
        });
    };
    AccountStore.prototype.api = function () {
        return {
            getClientInfo: function () {
                return Q(http.get("DRSP/Account/GetClientInfoByDomain"));
            },
            getUserLogin: function (param) {
                return Q(http.post("DRSP/Account/UserLogin", param, __assign({}, Api.header(["formdata", "xhr"]))));
            },
            forGotPasswordSendEmail: function (email) {
                return Q(http.post("DRSP/RetrievePassword/SendEmail", { email: email }, __assign({}, Api.header(["formdata", "xhr"]))));
            },
            // Answers { IsSuccess, Result }; Result is the message to show on failure.
            forgotPasswordByUserName: function (userName) {
                return Q(http.post("DRSP/RetrievePassword/ForgotPwd", { resetUserNamePwd: userName }, __assign({}, Api.header(["formdata", "xhr"]))));
            },
            forGotPasswordSendVerificationCode: function (phone) {
                return Q(http.post("DRSP/RetrievePassword/SendVerificationCode", { phone: phone }, __assign({}, Api.header(["formdata", "xhr"]))));
            },
            sendOneTimeCode: function (query) {
                return Q(http.post("otp/passcode/send", query, __assign({}, Api.header(["formdata", "xhr"]))));
            },
            verifyOneTimeCode: function (query) {
                return Q(http.post("otp/passcode/verify", query, __assign({}, Api.header(["formdata", "xhr"]))));
            },
            verifyCode: function (phoneNumber, code) {
                return Q(http.post("DRSP/RetrievePassword/CheckVerificationCode", { phone: phoneNumber, verificationCode: code }, __assign({}, Api.header(["formdata", "xhr"]))));
            },
            resetPassword: function (resetPasswordModel) {
                return Q(http.post("DRSP/RetrievePassword/SetNewPassword", resetPasswordModel, __assign({}, Api.header(["formdata", "xhr"]))));
            },
            checkEmailToken: function (request) {
                return Q(http.post("DRSP/RetrievePassword/CheckEmailToken", request, __assign({}, Api.header(["formdata", "xhr"]))));
            },
            checkEmail: function (email) {
                return Q(http.post("DRSP/Account/CheckEmailCanSignUp", { email: email }));
            },
            sendEmailByToken: function (token) {
                return Q(http.post("DRSP/Account/SendSignUpEmail", { token: token }));
            },
            createUserByEmail: function (userAccount) {
                return Q(http.post("DRSP/Account/CreateUser", userAccount));
            },
            getResidentInfo: function (residentId, token, clientId) {
                // Passed as params so axios encodes them, rather than concatenated raw into the URL.
                return Q(http.get("DRSP/Account/GetResidentById", { params: { residentId: residentId, clientId: clientId, token: token } }));
            },
            getSignUpByEmail: function (residentId, token, clientId) {
                return Q(http.get("DRSP/Account/signUpByEmail?step=2&residentId=" + residentId + "&clientId=" + clientId + "&token=" + token));
            },
            CheckCreateUserName: function (userName) {
                return Q(http.get("DRSP/Account/CheckCreateUserName?userName=" + userName));
            },
            register: function (userIdentity) {
                return Q(http.post("DRSP/Account/Register", userIdentity));
            },
            verifyOTP: function (request) {
                return Q(http.post("OTPAuthenticate/VerifyOTPSolution", request));
            },
            getResidentDetailsByPhone: function (phoneNumber, clientCode) {
                return Q(http.get("OTPAuthenticate/FindClientResidentByPhoneNumber?phone=" + phoneNumber + "&clientCode=" + clientCode));
            },
            getResidentContactListByLocation: function (request) {
                return Q(http.post("OTPAuthenticate/FindResidentsByLocationInfo", request));
            },
            getCallCenterPhone: function (clientCode) {
                return Q(http.get("OTPAuthenticate/GetCallCenterPhone?clientCode=" + clientCode));
            },
            getResidentAddress: function (query, clientId) {
                return Q(http.get("OTPAuthenticate/GetLocationAddress?query=" + query + "&clientId=" + clientId));
            },
            getResidentCity: function (query, clientId) {
                return Q(http.get("OTPAuthenticate/GetLocationCity?query=" + query + "&clientId=" + clientId));
            },
            getResidentState: function (query, clientId) {
                return Q(http.get("OTPAuthenticate/GetLocationState?query=" + query + "&clientId=" + clientId));
            },
            signInByOTP: function (AccessKey, eventId) { return http.post("OTPAuthenticate/SignIn", { AccessKey: AccessKey, eventId: eventId }); },
            sendOTPToPhone: function (request) {
                return Q(http.post("OTPAuthenticate/SendOTPSolutionGeneric", request));
            },
            logout: function () { return http.post("/DRSP/Account/SignOut"); },
            getConfirmedPhone: function () {
                return Q(http.get("/LocationResident/profile/phone/confirmed"));
            }
        };
    };
    __decorate([
        observable
    ], AccountStore.prototype, "clientInfo", void 0);
    __decorate([
        action
    ], AccountStore.prototype, "getClientInfo", null);
    __decorate([
        observable
    ], AccountStore.prototype, "userLoginData", void 0);
    __decorate([
        action
    ], AccountStore.prototype, "userLogin", null);
    __decorate([
        action
    ], AccountStore.prototype, "forGotPasswordSendEmail", null);
    __decorate([
        action
    ], AccountStore.prototype, "forgotPasswordByUserName", null);
    __decorate([
        action
    ], AccountStore.prototype, "forGotPasswordSendVerificationCode", null);
    __decorate([
        action
    ], AccountStore.prototype, "sendOneTimeCode", null);
    __decorate([
        action
    ], AccountStore.prototype, "verifyOneTimeCode", null);
    __decorate([
        action
    ], AccountStore.prototype, "verifyCode", null);
    __decorate([
        action
    ], AccountStore.prototype, "checkEmailToken", null);
    __decorate([
        action
    ], AccountStore.prototype, "createUserByEmail", null);
    __decorate([
        observable
    ], AccountStore.prototype, "userIdentity", void 0);
    __decorate([
        action
    ], AccountStore.prototype, "register", null);
    __decorate([
        action
    ], AccountStore.prototype, "sendEmailByToken", null);
    __decorate([
        observable
    ], AccountStore.prototype, "residentInfo", void 0);
    __decorate([
        action
    ], AccountStore.prototype, "getResidentInfo", null);
    __decorate([
        observable
    ], AccountStore.prototype, "jumpUrl", void 0);
    __decorate([
        action
    ], AccountStore.prototype, "getSignUpByEmail", null);
    __decorate([
        action
    ], AccountStore.prototype, "checkEmail", null);
    __decorate([
        observable
    ], AccountStore.prototype, "checkCreateUserName", void 0);
    __decorate([
        action
    ], AccountStore.prototype, "getCheckCreateUserNameResult", null);
    __decorate([
        observable
    ], AccountStore.prototype, "resetPasswordResult", void 0);
    __decorate([
        action
    ], AccountStore.prototype, "resetPassword", null);
    __decorate([
        action
    ], AccountStore.prototype, "getResidentDetailByPhone", null);
    __decorate([
        action
    ], AccountStore.prototype, "getResidentContactListByLocation", null);
    __decorate([
        action
    ], AccountStore.prototype, "verifyOtp", null);
    __decorate([
        action
    ], AccountStore.prototype, "getResidentAddress", null);
    __decorate([
        action
    ], AccountStore.prototype, "getCallCenterPhone", null);
    __decorate([
        action
    ], AccountStore.prototype, "getResidentCity", null);
    __decorate([
        action
    ], AccountStore.prototype, "getResidentState", null);
    __decorate([
        action
    ], AccountStore.prototype, "sendOTPToPhone", null);
    __decorate([
        action
    ], AccountStore.prototype, "getConfirmedPhone", null);
    return AccountStore;
}());
export default AccountStore;
